export const SubmittedToEwaForFinalCertificationDialogMessage = {
    modalTitle:
        'Your application has been submitted to EWA for final certification.',
    modalContent: 'Check the dashboard for status updates.',
    primaryActionTitle: 'Return to Dashboard',
} as const;
